












































































import Vue, { PropType } from 'vue';
import {
  Option,
  options,
  // Item,
  Sku,
} from 'mostra';

export type DataType = {
  skuDisabledTypes: Option;
};

export default Vue.extend({
  name: 'GItemSkuForm',
  props: {
    sku: {
      type: Object as PropType<Sku>,
      required: true,
    },
  },
  computed: {
    isPriceUndecided: {
      get(): boolean {
        return !!this.sku.isPriceUndecided;
      },
      set(val: boolean) {
        this.sku.isPriceUndecided = val;
        if (val) {
          this.sku.price = 0;
        }
      },
    },
  },
  data(): DataType {
    return {
      skuDisabledTypes: options.skuDisabledTypes,
    };
  },
});
